import React from 'react';
import { Smartphone, Apple, ExternalLink } from 'lucide-react';

const AppDownloadBanner = () => {
  return (
    <div className="bg-[#0F172A] px-6 py-8" data-testid="app-download-banner">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10">
        {/* Icon */}
        <div className="flex-shrink-0 w-16 h-16 bg-[#E07A3A]/10 flex items-center justify-center">
          <Smartphone className="h-8 w-8 text-[#E07A3A]" />
        </div>

        {/* Text */}
        <div className="flex-1 text-center md:text-left">
          <h3 className="font-['Playfair_Display'] text-xl text-white font-semibold mb-1">
            Shopperden on Mobile
          </h3>
          <p className="text-white/40 text-sm">
            Browse properties, track your journey, and connect with sellers — all from your phone. Coming soon to iOS and Android.
          </p>
        </div>

        {/* Badges */}
        <div className="flex gap-3 flex-shrink-0">
          <a
            href="https://apps.apple.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-5 py-3 bg-white/5 border border-white/10 hover:border-white/30 transition-colors"
            data-testid="app-store-badge"
          >
            <Apple className="h-5 w-5 text-white" />
            <div className="text-left">
              <span className="block text-[9px] text-white/40 uppercase tracking-wider">Download on the</span>
              <span className="block text-sm text-white font-semibold -mt-0.5">App Store</span>
            </div>
          </a>
          <a
            href="https://play.google.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-5 py-3 bg-white/5 border border-white/10 hover:border-white/30 transition-colors"
            data-testid="play-store-badge"
          >
            <svg viewBox="0 0 24 24" className="h-5 w-5 text-white" fill="currentColor">
              <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 2.302-2.302 2.302L15.396 12l2.302-2.302zM5.864 2.658L16.8 8.99l-2.302 2.302-8.635-8.635z"/>
            </svg>
            <div className="text-left">
              <span className="block text-[9px] text-white/40 uppercase tracking-wider">Get it on</span>
              <span className="block text-sm text-white font-semibold -mt-0.5">Google Play</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
